module.exports = __webpack_public_path__ + "static/media/grid-item-b12.15506a20.png";